import {
  ParsedWPBlock,
  PlayerCardType,
  WP_BLOCK_TYPE,
} from "@/src/types/Embeds";
import DangerouslySetHtmlContent from "../Article/Content/ExecutableScript";
import PlayerCard from "../Article/Embeds/PlayerCard/PlayerCard";
import SmallPlayerCard from "../Article/Embeds/PlayerCard/SmallPlayerCard";
import Twitter from "../Article/Embeds/TwitterBlock";
import TwitterBlock from "../Article/Embeds/TwitterBlock";
import ImageBlock from "../Article/Embeds/Image";
export interface RawContentProps {
  block: ParsedWPBlock;
}
const RawContent = ({ block }: RawContentProps) => {
  console.log("BlocKL: ", block);
  switch (block.type) {
    case WP_BLOCK_TYPE.PLAYER_CARD:
      return <SmallPlayerCard cardData={block.data as PlayerCardType} />;
    case WP_BLOCK_TYPE.RAW:
      if (block.category === "twitter") {
        return <TwitterBlock block={block} />;
      } else if (block.category === "image") {
        return <ImageBlock block={block} />;
      }
      return (
        <DangerouslySetHtmlContent
          html={block.content}
          allowRerender
          className=""
        />
      );
    default:
      return (
        <DangerouslySetHtmlContent
          html={block.content}
          allowRerender
          className=""
        />
      );
  }
};

export default RawContent;
